import Markdown from 'react-markdown';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import RichText from '@/components/utilities/RichText';

const COLORS = {
  grey_700: 'text-grey-700',
  grey_500: 'text-grey-500',
  black: 'text-black',
  white: 'text-white',
  brand_400: 'text-brand-400',
  brand_500: 'text-brand-500'
};

const H2 = ({ title, subtitle, text, textColor, h2align: align, htmlId }) => {
  let classNameAlign = 'text-left';
  if (align === 'center') {
    classNameAlign = 'text-center mx-auto';
  } else if (align === 'right') {
    classNameAlign = 'text-right';
  }

  const classNameTextColor = COLORS[textColor] || COLORS['grey-700'];

  return (
    <>
      {subtitle && (
        <VisibleLoading delay={75}>
          {({ ref, className }) => (
            <div ref={ref} className={`txt-md mt-2 mb-2 font-semibold uppercase ${classNameAlign} ${className || ''}`}>
              {subtitle}
            </div>
          )}
        </VisibleLoading>
      )}

      <VisibleLoading delay={100}>
        {({ ref, className }) => (
          <h2 id={htmlId} ref={ref} className={`${classNameAlign} ${className || ''}`.trim()}>
            <RichText>{title}</RichText>
          </h2>
        )}
      </VisibleLoading>

      {text && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <div
              ref={ref}
              className={`txt-xl whitespace-pre-wrap ${classNameTextColor} mt-4 ${classNameAlign} ${className} [&_a]:underline`.trim()}
            >
              <Markdown
                components={{
                  a: ({ href, children }) => {
                    const isExternal = href && !href.startsWith('/') && !href.startsWith('#');
                    return (
                      <a href={href} {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                        {children}
                      </a>
                    );
                  }
                }}
              >
                {text}
              </Markdown>
            </div>
          )}
        </VisibleLoading>
      )}
    </>
  );
};
export default H2;
